import { Router } from '@angular/router';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, filter, switchMap, take } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { NotificationService } from '../services/notification.service';
import { AuthService } from '../services/auth.service';
import { StorageService } from '../services/storage.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<string | null> =
    new BehaviorSubject<string | null>(null);

  constructor(
    private notificationService: NotificationService,
    private auth: AuthService,
    private storageService: StorageService,
    private router: Router,
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    const currentClient = this.storageService.get('currentClient');
    const modifiedHeaders =
      currentClient && request?.headers?.has('Authorization') === false
        ? { Authorization: `Bearer ${currentClient}` }
        : {};

    request = request.clone({
      setHeaders: {
        ...modifiedHeaders,
      },
    });

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        // 401 is now handled by ErrorInterceptor which forces a logout.
        // For other errors, collect and rethrow
        const data = {
          reason: error && error.error?.reason ? error.error?.reason : '',
          status: error?.status,
          causedBy: error.error?.error_description,
        };
        this.auth.handleHttpError(data);
        return throwError(() => error);
      }),
    );
  }

}
